import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BadgeType } from './badge-types';

@Injectable({
    providedIn: 'root',
})
export class BadgeNotifierService {
    private readonly badges = new Map<BadgeType, BehaviorSubject<boolean>>();

    /**
     * Retrieves the status of a specified badge
     * @param badgeType type of badge to retrieve
     * @returns whether the specified badge is active
     */
    getBadgeStatus(badgeType: BadgeType): Observable<boolean> {
        let badgeSubject = this.badges.get(badgeType);
        if (!badgeSubject) {
            badgeSubject = new BehaviorSubject(false);
            this.badges.set(badgeType, badgeSubject);
        }
        return badgeSubject.asObservable();
    }

    /**
     * Retrieves the status of a specified badge
     * @param badgeType type of badge to retrieve
     * @param status whether the badge's status is active
     */
    setBadgeStatus(badgeType: BadgeType, status: boolean): void {
        let badgeSubject = this.badges.get(badgeType);
        if (!badgeSubject) {
            badgeSubject = new BehaviorSubject(status);
            this.badges.set(badgeType, badgeSubject);
        }
        badgeSubject.next(status);
    }
}
